.optionItem {
    padding: 8px 16px;
}

.optionContainer {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 12px;
}

.addIcon {
    font-size: 18px;
    color: #4CAF50;
}

.checkboxContainer {
    position: relative;
    width: 18px;
    height: 18px;
}

.checkboxBox {
    width: 100%;
    height: 100%;
    border: 1px solid #9E9E9E;
    border-radius: 2px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.checkboxBoxSelected {
    border-color: #4CAF50;
    background-color: #4CAF50;
}

.checkmark {
    width: 12px;
    height: 12px;
    color: #FFFFFF;
}

.labelText {
    display: block;
    width: 100%;
    flex: 1;
}

